// extracted by mini-css-extract-plugin
export default {"hover-wrapper":"_2FtSP","hoverWrapper":"_2FtSP"};